import { type IconName } from '@aspendental/shared-components-web';

import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';

export interface ReasonForVisit {
	value: DigitalVisitReasonEnum;
	icon: IconName;
	label: string;
}

export const REASONS_FOR_VISIT: ReasonForVisit[] = [
	{
		value: DigitalVisitReasonEnum.Emergency,
		icon: 'Emergency',
		label: 'Emergency',
	},
	{
		value: DigitalVisitReasonEnum.BrokenToothToothPain,
		icon: 'BrokenTooth',
		label: 'Broken Tooth/Tooth Pain',
	},
	{
		value: DigitalVisitReasonEnum.Implants,
		icon: 'Implant',
		label: 'Dental Implants',
	},
	{
		value: DigitalVisitReasonEnum.Dentures,
		icon: 'Dentures',
		label: 'Dentures',
	},
	{
		value: DigitalVisitReasonEnum.ClearAligners,
		icon: 'Invisalign',
		label: 'Motto™ Clear Aligners',
	},
	{
		value: DigitalVisitReasonEnum.Other,
		icon: 'CheckUp',
		label: 'Other/Check Up',
	},
];

export const REASONS_FOR_VISIT_ES: ReasonForVisit[] = [
	{
		value: DigitalVisitReasonEnum.Emergency,
		icon: 'Emergency',
		label: 'Emergencia',
	},
	{
		value: DigitalVisitReasonEnum.BrokenToothToothPain,
		icon: 'BrokenTooth',
		label: 'Diente roto/dolor de muelas',
	},
	{
		value: DigitalVisitReasonEnum.Implants,
		icon: 'Implant',
		label: 'Implantes dentales',
	},
	{
		value: DigitalVisitReasonEnum.Dentures,
		icon: 'Dentures',
		label: 'Dentaduras postizas',
	},
	{
		value: DigitalVisitReasonEnum.ClearAligners,
		icon: 'Invisalign',
		label: 'Alineadores transparentes Motto™',
	},
	{
		value: DigitalVisitReasonEnum.Other,
		icon: 'CheckUp',
		label: 'Otro/Chequeo',
	},
];

const reasonMap = (array: ReasonForVisit[]) =>
	array.reduce((obj, item, index) => {
		obj[item.value] = ++index;
		return obj;
	}, {});

export const REASON_FOR_VISIT_ID = reasonMap(REASONS_FOR_VISIT);
export const REASON_FOR_VISIT_ID_ES = reasonMap(REASONS_FOR_VISIT_ES);
